import Layout from "@/components/site/Layout";
import PageHero from "@/components/site/PageHero";
import Contact from "@/components/site/Contact";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { OC_OCEAN_VIDEO_URL, OC_PIER_SUNSET_URL } from "@/lib/assets";

const QUICK = [
  { icon: Phone, label: "Call Us", value: "(714) 391-3645", sub: "9:00am – 6:00pm" },
  { icon: Mail, label: "Email", value: "marynguyenrealtor@gmail.com", sub: "Replies within 4 business hours" },
  { icon: MapPin, label: "Visit", value: "2134 Main St. Suite 140", sub: "Huntington Beach, CA 92648" },
  { icon: Clock, label: "Hours", value: "9:00am – 6:00pm", sub: "By appointment only" },
];

export default function ContactPage() {
  return (
    <Layout>
      <PageHero
        breadcrumb="Home / Contact Us"
        overline="Let's Talk"
        title="We're here when"
        accentWord="you're ready."
        description="There's no script and no pressure — just a quiet conversation about what your family is facing and how we can help carry the weight."
        image="https://images.unsplash.com/photo-1581609836630-9007630f7a7b?w=1600&q=80"
        rightVideo={OC_OCEAN_VIDEO_URL}
        rightVideoPoster={OC_PIER_SUNSET_URL}
      />

      <section className="py-12 bg-white" data-testid="quick-contact">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {QUICK.map((q, i) => (
              <a
                key={q.label}
                href={q.label === "Call Us" ? "tel:+17143913645" : q.label === "Email" ? `mailto:${q.value}` : "#contact"}
                data-testid={`quick-${i}`}
                className="group rounded-2xl border border-navy-100 bg-navy-50/40 p-6 hover:border-gold-400 hover:bg-white hover:shadow-md transition-all"
              >
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-navy-900 text-gold-400">
                  <q.icon size={16} />
                </div>
                <div className="mt-4 text-[10px] uppercase tracking-[0.22em] text-navy-500 font-semibold">{q.label}</div>
                <div className="mt-1 font-heading text-base text-navy-900">{q.value}</div>
                <div className="text-xs text-navy-600 mt-0.5">{q.sub}</div>
              </a>
            ))}
          </div>
        </div>
      </section>

      <Contact />
    </Layout>
  );
}
